import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {
    receiveLoginData,
    updateApplicationState,
} from 'flow/actions/app-actions';
import { useAppDispatch } from 'flow/hooks/useRedux';

const useUaePassSuccessRedirect = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();

    return useCallback(() => {
        dispatch(receiveLoginData({ error: false, waiting: false }));
        dispatch(updateApplicationState('boot'));
        history.push('/');
    }, [dispatch, history]);
};

export default useUaePassSuccessRedirect;
